import { video_curated_playlist_update } from "./actions";
import { getPolopolyVideoByLineupSlug } from "../../fetch/graphql/requests/video/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { PLAYLIST } from "../../components/LayoutFactory/constants";

export const fetchVideoByLineup = (lineupSlug, path) => {
    return async (dispatch) => {
        try {
            const response = await getPolopolyVideoByLineupSlug(lineupSlug, 10);

            const contextualHeadlineSlug = lineupSlug ?? "";

            const transformedItems = transformAllContentItems(
                response.allContentItems.nodes,
                contextualHeadlineSlug
            );

            const layout = { name: PLAYLIST };
            const featureAttributionData = {
                instance: "News",
            };

            const playlistItems = transformForLayouts(
                transformedItems,
                layout,
                path,
                featureAttributionData
            );

            const payload = {
                video: {
                    data: {
                        curatedPlaylist: playlistItems,
                    },
                },
            };
            return dispatch(video_curated_playlist_update(payload));
        } catch (error) {
            const payload = {
                video: { data: { curatedPlaylist: [] } },
            };
            return dispatch(video_curated_playlist_update(payload));
        }
    };
};
